module.exports = __webpack_public_path__ + "img/pdf.50a53987.svg";